import React, {useState, useEffect} from 'react';
import { Box, List, ListItem, ListItemButton, ListItemText, IconButton,  Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { makeStyles } from "@material-ui/core/styles";

const InsightList = (props) => {
  const insightQuestions = [
    { title: "Students who have attempted the least number of assignments.", type: "least_attempted_assignments" },
    { title: "Students who have attempted the largest number of assignments.", type: "most_attempted_assignments" },
    { title: "Students who are at the top on the performance chart.", type: "learner_top_of_class" },
    //{ title: "Which children have scored less than 50%?", type:'scored_leass_than_50'}
  ];

  //Hooks
  const styles = useStyles();

  //State
  const [selectedQType, setSelectedQType] = useState(null);
  
  useEffect(() => {
    setSelectedQType(null);
  },[props.selectedClassId])
  
  const handleSelectQuestion = (qType) => {
    setSelectedQType(qType);
    props.handleQuestionAns(qType);
  };

  return (
    <Box>
      <List>
        {insightQuestions.map((insightData, index) => {
          return (
            <ListItem
              key={`${'insight_q_'+index}`}
              disablePadding
              sx={{ border: 1, borderColor: '#EAECEE', borderRadius: 10, mb: 2 }}
              onClick={() => { handleSelectQuestion(insightData.type) }}
              secondaryAction={
                <IconButton edge="end" au6ria-label="comments" sx={{ color: 'primary.main' }}>
                  <NavigateNextIcon sx={{ fontSize: '1.2rem', '@media (min-width: 1636px)': { fontSize: '2rem' } }} />
                </IconButton>
              }
              className={`${(selectedQType == insightData.type) ? styles.activeText : ""}`}              
            >
              <ListItemButton sx={{ borderRadius: 5, }} dense>
                <ListItemText sx={{ color: 'primary.main' }}>
                  <Typography sx={{ fontSize: '0.95rem', fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                    {insightData.title}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          )
        })}        
      </List>
    </Box>
  );
}
const useStyles = makeStyles({
  activeText: {
    backgroundColor: '#d7e2f2',
  }
});

export default InsightList;